// src/pages/Appli/AppliAdmin/VisitorCenter/components/VisitorTopPagesTable.jsx

import React from "react";

import {
  FiFileText,
} from "react-icons/fi";

import {
  EmptyState,
  SectionCard,
} from "../ui/VisitorCenterUi";

import {
  formatCompactNumber,
  formatDuration,
  formatPageLabel,
  formatPercentage,
  safeNumber,
} from "../utils/visitorFormatters";

export default function VisitorTopPagesTable({
  rows = [],
}) {
  const maxViews = Math.max(
    ...rows.map((row) =>
      safeNumber(row.views),
    ),
    1,
  );

  return (
    <SectionCard
      title="Pages les plus consultées"
      subtitle="Classement des contenus qui attirent le plus les visiteurs."
    >
      {rows.length ? (
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-[#F8FBFD] text-left text-xs uppercase tracking-[0.1em] text-slate-400">
              <tr>
                <th className="px-5 py-4">
                  Page
                </th>

                <th className="px-5 py-4 text-right">
                  Vues
                </th>

                <th className="px-5 py-4 text-right">
                  Sessions
                </th>

                <th className="px-5 py-4 text-right">
                  Durée moyenne
                </th>

                <th className="px-5 py-4 text-right">
                  Sorties
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100">
              {rows.map(
                (row, index) => {
                  const progress =
                    Math.max(
                      4,
                      Math.round(
                        (
                          safeNumber(
                            row.views,
                          ) /
                          maxViews
                        ) *
                          100,
                      ),
                    );

                  return (
                    <tr
                      key={`${row.page}-${index}`}
                      className="transition hover:bg-[#F8FBFD]"
                    >
                      <td className="min-w-[280px] px-5 py-4">
                        <div className="flex items-start gap-3">
                          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[#EEF7FC] text-sm font-extrabold text-[#123B57]">
                            {index + 1}
                          </div>

                          <div className="min-w-0 flex-1">
                            <div className="truncate font-extrabold text-[#123B57]">
                              {row.page_title ||
                                formatPageLabel(
                                  row.page,
                                )}
                            </div>

                            <div className="mt-1 truncate text-xs text-slate-400">
                              {row.page}
                            </div>

                            <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-slate-100">
                              <div
                                className="h-full rounded-full bg-[#2EA7E0]"
                                style={{
                                  width:
                                    `${progress}%`,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </td>

                      <td className="px-5 py-4 text-right font-extrabold text-[#123B57]">
                        {formatCompactNumber(
                          row.views,
                        )}
                      </td>

                      <td className="px-5 py-4 text-right text-sm font-semibold text-slate-600">
                        {formatCompactNumber(
                          row.sessions,
                        )}
                      </td>

                      <td className="px-5 py-4 text-right text-sm font-semibold text-slate-600">
                        {formatDuration(
                          row.average_duration_seconds,
                        )}
                      </td>

                      <td className="px-5 py-4 text-right text-sm font-semibold text-slate-600">
                        {formatPercentage(
                          row.exit_rate,
                        )}
                      </td>
                    </tr>
                  );
                },
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyState
          icon={FiFileText}
          title="Aucune page consultée"
          description="Le classement apparaîtra dès que des pages auront été visitées."
        />
      )}
    </SectionCard>
  );
}